<template>
    <div id="app" class="app" v-bind:class="{
		'app-sidebar-minified': appOptions.appSidebarMinified,
		'app-sidebar-mobile-toggled': appOptions.appSidebarMobileToggled,
		'app-sidebar-mobile-closed': appOptions.appSidebarMobileClosed,
		'app-content-full-height': appOptions.appContentFullHeight,
		'app-content-full-width': appOptions.appContentFullWidth,
		'app-without-sidebar': appOptions.appWithoutSidebar,
		'pt-0': appOptions.appWithoutHeader,
		'app-boxed-layout': appOptions.appBoxedLayout,
		'app-footer-fixed': appOptions.appWithFooter
	}">
        <router-view></router-view>

    </div>
</template>

<script>
    import AppOptions from './config/AppOptions.vue'
    export default {
        name: 'App',
        rootPath: "http://localhost:8080/dodo_TRM", //后台接口路径
        //rootPath: "https://pilot.embraiz.com/server", //后台接口路径
        userId:'',
        data() {
            return {
                appOptions: AppOptions,
            }
        },
        created() {
            this.$router.beforeEach((to, from, next) => {
                if (this.appOptions.appSidebarMobileToggled === true) {
                    this.appOptions.appSidebarMobileClosed = true;
                    setTimeout(() => {
                        this.appOptions.appSidebarMobileClosed = false;
                        this.appOptions.appSidebarMobileToggled = false;
                    }, 250);
                }
                next()
            })
        }
    }
</script>
<style lang="scss">
    @import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
    @import "../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css";
    @import 'scss/vue-multiselect.min.css';
    @import 'scss/main.css';
</style>
